<template>
  <out-layout>
    <header slot="form-header" class="header">
      <h2 class="title">Esqueci a Senha</h2>
      <p class="subtitle">Digite seu CPF e e-mail nos campos abaixo para receber
        as instruçoes para acessar sua conta.</p>
    </header>

    <v-form v-model="valid" slot="form-content">
      <fieldset class="fieldset">
          <v-text-field
            name="login"
            v-model="cpf"
            :rules="cpfRules"
            mask="###.###.###-##"
            label="CPF"
            required
            type="text">
          </v-text-field>

          <v-text-field
            name="email"
            :rules="emailRules"
            v-model="email"
            label="E-mail"
            required
            type="text">
          </v-text-field>
        <v-card-actions class="action">
          <v-btn color="primary" v-on:click="sendResetPasswordInstructions()" :disabled="!valid">
            Enviar instruções
          </v-btn>
        </v-card-actions>
      </fieldset>
    </v-form>
    <template slot="navigation">

      <v-btn flat small color="primary" class="link" :to="{name: 'requerenteSignIn'}">
        <v-icon left>mdi-account-circle</v-icon>
        <span class="text">Voltar ao login</span>
      </v-btn>
    </template>

  </out-layout>
</template>

<script>
import OutLayout from '@/layouts/OutLayout';
import UserService from '@/services/UserService';

export default {
  name: 'RecoveryPassword',
  components: {
    OutLayout,
  },
  data() {
    return {
      cpf: '',
      email: '',
      loading: false,
      valid: false,
      cpfRules: [
        v => !!v || 'Campo obrigatório',
        v => (v && v.length === 11) || 'CPF deve ter 11 dígitos',
      ],
      emailRules: [
        v => !!v || 'Campo obrigatório',
        v => /.+@.+/.test(v) || 'E-mail não é válido',
      ],
    };
  },
  methods: {
    sendResetPasswordInstructions() {
      this.$store.dispatch('setLoadingDialog', true);
      this.loading = true;
      const vm = this;
      const userParams = {
        cpf: vm.cpf,
        email: vm.email,
      };
      UserService
        .sendResetPasswordInstructions(userParams)
        .then(() => {
          vm
            .$swal({ title: 'Solicitação enviada com sucesso' })
            .then(() => {
              vm.$router.push({ name: 'requerenteSignIn' });
            });
        })
        .catch(() => {
          vm
            .$swal({
              title: 'Atenção',
              type: 'error',
              text: 'Não foi possível localizar uma conta com os CPF/E-mail informados',
            });
        })
        .finally(() => {
          this.$store.dispatch('setLoadingDialog', false);
        });
    },
  },
};
</script>

<style scoped lang="scss">
</style>
